/**
 * Quick View Modal - EVSTORE
 * Fetches product data via Shopify AJAX API and renders in modal
 */
(function () {
    'use strict';

    const modal = document.getElementById('quick-view-modal');
    if (!modal) return;

    const content = modal.querySelector('[data-quick-view-content]');
    const closeBtn = modal.querySelector('[data-quick-view-close]');

    // Quick View: delegate click on product cards
    document.addEventListener('click', function (e) {
        const trigger = e.target.closest('[data-quick-view]');
        if (!trigger) return;
        e.preventDefault();
        e.stopPropagation();

        const handle = trigger.dataset.quickView;
        if (!handle) return;

        openQuickView(handle);
    });

    // Close modal
    if (closeBtn) {
        closeBtn.addEventListener('click', closeQuickView);
    }

    modal.addEventListener('click', function (e) {
        if (e.target === modal) closeQuickView();
    });

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) {
            closeQuickView();
        }
    });

    function openQuickView(handle) {
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';

        content.innerHTML = '<div class="quick-view-modal__loading"><div class="spinner"></div></div>';

        fetch('/products/' + handle + '.js')
            .then(function (r) { return r.json(); })
            .then(function (product) {
                renderQuickView(product);
            })
            .catch(function () {
                content.innerHTML = '<p style="text-align:center;padding:40px;">Impossibile caricare il prodotto.</p>';
            });
    }

    function closeQuickView() {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
    }

    function renderQuickView(product) {
        var variant = product.variants[0];
        var image = product.featured_image || product.images[0] || '';
        var compareHtml = '';

        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareHtml = '<span class="compare-price">' + formatMoney(variant.compare_at_price) + '</span>';
        }

        var desc = product.description || '';
        // Strip HTML tags for a clean preview
        var tempEl = document.createElement('div');
        tempEl.innerHTML = desc;
        var descText = tempEl.textContent || tempEl.innerText || '';
        if (descText.length > 250) descText = descText.substring(0, 250) + '...';

        var availableClass = variant.available ? '' : ' disabled';
        var btnText = variant.available ? 'Aggiungi al Carrello' : 'Esaurito';

        var html = '<div class="quick-view-modal__grid">';
        html += '<div class="quick-view-modal__image">';
        if (image) {
            html += '<img src="' + image + '" alt="' + escapeHtml(product.title) + '" loading="eager">';
        }
        html += '</div>';
        html += '<div class="quick-view-modal__info">';
        if (product.vendor) {
            html += '<div class="quick-view-modal__info-vendor">' + escapeHtml(product.vendor) + '</div>';
        }
        html += '<h2 class="quick-view-modal__info-title">' + escapeHtml(product.title) + '</h2>';
        html += '<div class="quick-view-modal__info-price">' + formatMoney(variant.price) + compareHtml + '</div>';
        if (descText) {
            html += '<p class="quick-view-modal__info-desc">' + escapeHtml(descText) + '</p>';
        }
        if (variant.available) {
            html += '<form class="quick-view-modal__add-form" action="/cart/add" method="post">';
            html += '<input type="hidden" name="id" value="' + variant.id + '">';
            html += '<input type="number" name="quantity" value="1" min="1" class="quick-view-modal__qty">';
            html += '<button type="submit" class="quick-view-modal__add-btn' + availableClass + '">' + btnText + '</button>';
            html += '</form>';
        } else {
            html += '<button class="quick-view-modal__add-btn" disabled style="width:100%;opacity:0.5;cursor:not-allowed;padding:var(--space-3)">' + btnText + '</button>';
        }
        html += '<a href="/products/' + product.handle + '" class="quick-view-modal__view-full">Vedi dettagli completi →</a>';
        html += '</div>';
        html += '</div>';

        content.innerHTML = html;
    }

    function formatMoney(cents) {
        return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }

    function escapeHtml(str) {
        var div = document.createElement('div');
        div.textContent = str;
        return div.innerHTML;
    }
})();
